<template>
  <div>
    123
  </div>
</template>

<script>
export default {
  name: 'UserGroupSettingsDetail',
};
</script>



// WEBPACK FOOTER //
// UserGroupSettingsDetail.vue?30f5933c